import { redirect, type RouteObject } from 'react-router';

import { PermissionAction, PermissionResource } from '@entities/tenant/permission';

import { lazyComponent } from '../../../lazy-component';
import { requirePermission } from '../../../require-permission';
import { discountsLoader } from './discounts-loader';

export const discountsRoutes: RouteObject = {
  loader: discountsLoader,
  children: [
    {
      path: '/admin/discounts',
      lazy: lazyComponent(() => import('@pages/tenant/discounts'), 'DiscountsPage'),
      children: [
        { index: true, loader: () => redirect('/admin/discounts/list') },
        {
          path: 'list',
          lazy: lazyComponent(
            () => import('@pages/tenant/discounts'),
            'DiscountsListPage',
          ),
        },
        {
          path: 'groups',
          lazy: lazyComponent(
            () => import('@pages/tenant/discounts'),
            'DiscountsGroupsPage',
          ),
        },
        {
          path: 'clients',
          lazy: lazyComponent(
            () => import('@pages/tenant/discounts'),
            'DiscountsClientsPage',
          ),
        },
        {
          path: 'retro-bonus',
          lazy: lazyComponent(
            () => import('@pages/tenant/discounts'),
            'DiscountsRetroBonusPage',
          ),
        },
        {
          path: 'role-limits',
          lazy: lazyComponent(
            () => import('@pages/tenant/discounts'),
            'RoleDiscountLimitsPage',
          ),
        },
        {
          path: 'approval-requests',
          loader: () => redirect('/admin/discounts/approval-requests/incoming'),
        },
        {
          path: 'approval-requests/incoming',
          loader: requirePermission(
            PermissionResource.TenantDiscountApprovals,
            PermissionAction.Decide,
          ),
          lazy: lazyComponent(
            () => import('@pages/tenant/discounts'),
            'IncomingDiscountApprovalRequestsPage',
          ),
        },
        {
          path: 'approval-requests/mine',
          loader: requirePermission(
            PermissionResource.TenantDiscountApprovals,
            PermissionAction.Read,
          ),
          lazy: lazyComponent(
            () => import('@pages/tenant/discounts'),
            'MyDiscountApprovalRequestsPage',
          ),
        },
      ],
    },
  ],
};
